import { Link } from "react-router-dom";
import { Headphones } from "lucide-react";
import { formatShortDate, useApi } from "@/lib/api";
import { Container } from "@/components/site/PageHeader";
import { Label } from "@/components/site/SectionHeading";

export const FeaturedPodcast = () => {
  const { data } = useApi("/podcasts", { limit: 1 });
  const p = Array.isArray(data) ? data[0] : null;
  if (!p) return null;
  return (
    <section className="py-16 md:py-24 border-b border-white/10" data-testid="radio-featured-podcast">
      <Container>
        <Link to={`/podcasts/${p.slug}`} className="group grid grid-cols-1 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-8 md:gap-14 items-center" data-testid="radio-featured-podcast-link">
          <div className="overflow-hidden aspect-square bg-[hsl(var(--surface))]">
            <img src={p.image || "/brand/fallback-magazine.jpg"} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </div>
          <div className="min-w-0">
            <Label>Dernier podcast · {formatShortDate(p.date)}{p.podcast_type ? ` · ${p.podcast_type}` : ""}</Label>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] text-white mt-5 group-hover:text-primary transition-colors break-words" data-testid="radio-featured-podcast-title">
              {p.title}
            </h2>
            {p.excerpt && <p className="text-zinc-300 text-base sm:text-lg leading-relaxed mt-6 line-clamp-4 max-w-2xl">{p.excerpt}</p>}
            <span className="mt-8 inline-flex items-center gap-3 bg-primary text-white font-bold uppercase text-xs tracking-[0.2em] px-6 py-4 group-hover:bg-white group-hover:text-black transition-colors">
              <Headphones className="w-4 h-4" /> Écouter le podcast
            </span>
          </div>
        </Link>
      </Container>
    </section>
  );
};
